var memoization = {
    key: null,
    value: null
};
var GSESSION_ID = "gsessionId";
/**
 * This function register in the session storage that a message has been viewed in an specific page.
 * @param messageId
 * @param counter
 * @param supportSession when true the message will be displayed only {counter} times per session, otherwise it will be displayed {counter} times regardless of the session.
 */ export var registerMessageViewed = function(messageId) {
    var counter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, supportSession = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _localStorage_getItem;
    var viewedMessages = JSON.parse((_localStorage_getItem = localStorage.getItem("viewedMessages")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "{}") || {};
    var fullStoredKey = messageId;
    if (supportSession) {
        var sessionId = getCookie(GSESSION_ID);
        fullStoredKey = "".concat(messageId).concat(sessionId ? "GS".concat(sessionId) : "");
        viewedMessages = filterAndRemoveSessionKeys(viewedMessages, messageId, fullStoredKey);
    }
    var viewedCounter = parseInt(viewedMessages[fullStoredKey]) || 0;
    if (viewedCounter >= counter) {
        return "Message already viewed";
    }
    viewedMessages[fullStoredKey] = viewedCounter + 1;
    localStorage.setItem("viewedMessages", JSON.stringify(viewedMessages));
};
/**
 * This function checks if a message has been viewed in an specific page.
 * @param messageId
 * @param counter
 * @param supportSession
 * @returns
 */ export var isMessageViewed = function(messageId) {
    var counter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, supportSession = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var fullStoredKey = messageId;
    if (supportSession) {
        var sessionId = getCookie(GSESSION_ID);
        fullStoredKey = "".concat(messageId).concat(sessionId ? "GS".concat(sessionId) : "");
    }
    var _localStorage_getItem;
    var viewedMessages = JSON.parse((_localStorage_getItem = localStorage.getItem("viewedMessages")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "{}") || {};
    var viewedCounter = parseInt(viewedMessages[fullStoredKey]) || 0;
    memoization.value = viewedCounter >= counter;
    return memoization.value;
};
/**
 * This function identify and remove the session keys from the viewed messages.
 * @param viewedMessages 
 * @param messageId 
 * @param fullStoredKey 
 * @returns 
 */ function filterAndRemoveSessionKeys(viewedMessages, messageId, fullStoredKey) {
    var keys = Object.keys(viewedMessages).filter(function(key) {
        return key.includes("".concat(messageId, "GS"));
    });
    if (keys.length > 0 && !keys.some(function(key) {
        return key == fullStoredKey;
    })) {
        var filteredObject = Object.keys(viewedMessages).filter(function(key) {
            return !key.includes("".concat(messageId, "GS"));
        }).reduce(function(acc, key) {
            acc[key] = viewedMessages[key];
            return acc;
        }, {});
        viewedMessages = filteredObject;
    }
    return viewedMessages;
}
/**
 * This function reads a cookie by its name.
 * @param name
 * @returns
 */ function getCookie(name) {
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(name, "="));
    if (parts.length === 2) {
        var _parts_pop;
        return parts === null || parts === void 0 ? void 0 : (_parts_pop = parts.pop()) === null || _parts_pop === void 0 ? void 0 : _parts_pop.split(";").shift();
    } else return null;
}
